'use client';

import { motion } from 'framer-motion';
import { ServiceCard } from '@/app/services/components/services-card';
import { useInView } from 'react-intersection-observer';
import { useGetServices } from '@/hooks/react-query/useGetServices';
import { ServicesSkeleton } from './services-skeleton';
import { Service } from '@/types/service.types';

export function ServicesShowcase(): JSX.Element {
	const { ref } = useInView();
	const { data, isPending } = useGetServices();

	if (isPending) {
		return <ServicesSkeleton />;
	}

	return (
		<motion.div
			className="pt-4 pb-16 md:pt-6 md:pb-24"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.4, ease: 'easeOut' }}
		>
			<div className="space-y-16 md:space-y-24">
				{data?.map((service: Service, index: number) => (
					<ServiceCard key={service.id} service={service} index={index} />
				))}
			</div>
			<div ref={ref} className="h-16" />
		</motion.div>
	);
}
